export default "__VITE_ASSET__23088a40__"